module.exports = "\r\n<div class=\"w3-display-container\">\r\n\t<div class=\"w3-display-middle\">\r\n\t\t<h6 class=\"w3-text-gray font-6\">\r\n\t\t\t<i class=\"fa fa-ban w3-text-red\"></i> <b>Unauthorized.</b>\r\n\t\t</h6>\r\n\t\t<p class=\"w3-right\">Your are trying to do something you shouldn't. :(</p>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/errors/unauthorized/unauthorized.component.html
// module id = ./src/app/components/errors/unauthorized/unauthorized.component.html
// module chunks = main